<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="20" class="logo">
				<img src="../assets/logo4.png" /> <span>资讯<i class="txt">管理中心</i></span>
			</el-col>
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<!--<el-dropdown-item>我的消息</el-dropdown-item>-->
						<!--<el-dropdown-item>设置</el-dropdown-item>-->
						<el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
      <!--eslint-disable-->
			<aside>
				<el-menu :default-active="$route.path"  background-color="#324157" text-color="#bfcbd9" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose"
					theme="dark" unique-opened router>
					<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden&&userMenu[item.id]&&userMenu[item.id].show">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
							<el-menu-item v-for="child in item.children" :key="child.path" :index="child.path" v-if="!child.hidden&&userMenu[child.id]&&userMenu[child.id].show">{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
					</template>
					</el-menu>
			</aside>
      <!--eslint-enable-->
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<strong class="title">{{$route.name}}</strong>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition>
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
  import { getUserAccess,cleanToken } from '../api/api';
	export default {
    data() {
      return {
        sysUserName: '',
        sysUserAvatar: '',
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        userMenu: {}
      }
    },
//    computed: {
//      ...mapGetters([
//        'getUserAccess'
//      ])
//    },
    methods: {
//      ...mapActions([
//        'userAccess'
//      ]),
      handleopen() {
        //console.log('handleopen');
      },
      handleclose() {
        //console.log('handleclose');
      },
      //退出登录
      logout: function () {
        this.$confirm('确认退出吗?', '提示', {
        }).then(() => {
          this.$storejs.remove(process.env.VUE_APP_APPKEY+'token');
          sessionStorage.removeItem(process.env.VUE_APP_APPKEY+'userInfo');
          cleanToken()
          this.$router.push('/login');
        }).catch(() => {

        });


      }
    },
    mounted() {
      getUserAccess().then((res) => {
        let {data} = res;
        this.userMenu = data.data.userMenu
        this.$storejs.set(process.env.VUE_APP_APPKEY+"userAccess", data.data.userMenu);
      });
      var user = sessionStorage.getItem(process.env.VUE_APP_APPKEY+'userInfo');
      if (user) {
        user = JSON.parse(user);
        this.sysUserName = user.nickname || '';
        this.sysUserAvatar = user.avatar || 'data:image/png;base64,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';
      }
    }
  }

</script>

<style scoped lang="scss">
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: #1F2D3D;
			color: #c0ccda;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				.userinfo-inner {
					color: #c0ccda;
					cursor: pointer;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				font-size: 22px;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color: #20a0ff
				}
			}
		}
		.main {
			background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				width: 230px;
			}
			.content-container {
				background: #f1f2f7;
				position: absolute;
				right: 0px;
				top: 0px;
				bottom: 0px;
				left: 230px;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
</style>
